$(document).ready(() => {
  $('.slide-nav__overlay').on('click', () => {
    $('.slide-nav').removeClass('slide-nav--active');
    $('.slide-nav__overlay').removeClass('slide-nav__overlay--active');
  });

  $('.main-nav__hamburger').on('click', () => {
    $('.slide-nav').addClass('slide-nav--active');
    $('.slide-nav__overlay').addClass('slide-nav__overlay--active');
  });
});
